import React, { Key, useEffect, useMemo, useState } from "react";
import { Button, Table } from "antd";
import { Link } from "react-router-dom";
import { IPolicy } from "../../types/IPolicy";
import versionsTableUtils from "../../../../lib/utils/versionsTableUtils";
import { TableColumn } from "../../../../lib/interfaces";
import { useAppSelector } from "../../../..";
import { toDisplayFormat } from "../../../../lib/utils";

const columnsWidths = {
  ...versionsTableUtils.columnsWidths,
  name: "200px",
  typeId: "200px",
  status: "200px",
  actionId: "200px",
  fromDate: "100px",
  toDate: "100px",
};

interface TableData extends Partial<IPolicy> {
  key?: Key;
  actions?: string;
  buttons?: string;
}

interface IProps {
  offeringGroupsPolicy: IPolicy[];
  isLoading: boolean;
}

const OfferingGroupPolicyTable = ({ offeringGroupsPolicy, isLoading }: IProps) => {
  const { policiesTypesDic, policiesActionsDic, policiesStatusDic } = useAppSelector(
    (state) => state.policies
  );

  const tableData = useMemo((): TableData[] => {
    const data: TableData[] = offeringGroupsPolicy.map(
      ({ id, name, typeId, fromDate, toDate, actionId, status }) => ({
        key: id,
        id,
        name,
        typeId,
        fromDate,
        toDate,
        actionId,
        status,
      })
    );
    return data;
  }, [offeringGroupsPolicy]);

  const getColumns = (): TableColumn<TableData>[] => [
    {
      title: "Наименование",
      dataIndex: "name",
      key: "name",
      width: columnsWidths.name,
      hidden: false,
      render: (val, record) => {
        return <Link to={`/policies/${record.id}`}>{val}</Link>;
      },
    },
    {
      title: "Тип",
      dataIndex: "typeId",
      key: "typeId",
      width: columnsWidths.typeId,
      hidden: false,
      render: (typeId) => versionsTableUtils.getDictionaryItemById(policiesTypesDic, typeId)?.name,
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      width: columnsWidths.status,
      hidden: false,
      render: (status) => {
        return versionsTableUtils.getDictionaryItemById(policiesStatusDic, status)?.name;
      },
    },
    {
      title: "Действие",
      dataIndex: "actionId",
      key: "actionId",
      width: columnsWidths.actionId,
      hidden: false,
      render: (actionId) =>
        versionsTableUtils.getDictionaryItemById(policiesActionsDic, actionId)?.name,
    },
    {
      title: "Период с",
      dataIndex: "fromDate",
      key: "fromDate",
      width: columnsWidths.fromDate,
      hidden: false,
      render: (fromDate) => toDisplayFormat(fromDate),
    },
    {
      title: "Период по",
      dataIndex: "toDate",
      key: "toDate",
      width: columnsWidths.toDate,
      hidden: false,
      render: (toDate) => toDisplayFormat(toDate),
    },
    {
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      hidden: false,
    },
  ];

  const [columns, setColumns] = useState<TableColumn<TableData>[]>(getColumns());

  // Обновление колонок
  useEffect(() => {
    setColumns(getColumns());
  }, [policiesTypesDic, policiesActionsDic, policiesStatusDic, tableData]);

  return (
    <div>
      <Table columns={columns} dataSource={tableData} pagination={false} loading={isLoading} />
    </div>
  );
};

export default OfferingGroupPolicyTable;
